// extracted by mini-css-extract-plugin
export default {"aboutApp":"AboutPage_aboutApp__FjydD","githubLink":"AboutPage_githubLink__U4EVP"};